<p class="p1">{{'2. Select an amount' | translate}}

</p>
<p class="col-11 m-t-1"
   [sizeClass]="'S: p2, !S: p3'"
   *ifStore="'!us'">
    <span>{{( app.client.isS ? 'Wrong currency?' : 'Please purchase Gift Cards in the currency the receiver will use.')
        |
        translate}}</span>&nbsp;<button [iCmsModalOpen]="multisiteModalId"
            class="italic"
            style="text-decoration: underline;"
            type="button">{{(app.client.isS ? 'Change site' : 'Change currency') | translate}}</button>
</p>

<!-- amounts -->
<div class="w-12 m-t-5 m-t-2-s _amount">

    <!-- amount -->
    @for (value of amounts; track $index; let isLast = $last) {
    <button type="button"
            class="_button"
            [ngClass]="{'_active' : request?.am_giftcard_amount == value}"
            (click)="selectAmount(value)">
        <price [value]="value"
               class="p1"></price>
    </button>
    }
</div>

@if (!show) {
<button type="button"
        class="m-t button-1 w-12"
        (click)="toggleCustomAmountField(true)">
    <span class="button__body">{{'Other amount' | translate}}</span>
</button>
}

@if (show) {
<div class="m-t">
    <input-wrap class="block pos-relative"
                [canShowValidate]="displayCustomFieldInputError"
                [messages]="{numberMin: 'Minimum amount is ' + minAmount, numberMax: 'Maximum amount is ' + maxAmount}">
        <div class="pos-relative">
            <span
                  class="z-1 p1 pos-absolute flex flex-justify-center flex-middle left-4 top-0 bottom-0">{{currencySymbol}}</span>
            <input class="giftcards-input no-spinner center b-a p1 p-l-8 p-r-8"
                   [ngClass]="minError || maxError ? 'b-col-2' : 'b-col-b'"
                   [(ngModel)]="request.am_giftcard_amount_custom"
                   (change)="onCustomAmountChange()"
                   (ngModelChange)="updateCustomErrors()"
                   type="number"
                   (keypress)="onKeypress($event)"
                   inputmode="numeric"
                   placeholder="60.00"
                   name="am_giftcard_amount_custom"
                   validateNumber
                   required
                   validateMax="{{maxAmount}}"
                   validateMin="{{minAmount}}"
                   #inputAmount />
        </div>
    </input-wrap>
    <div class="p3 col-11 m-t-2">
        <span [ngClass]="{'col-2' : minError}">{{'Minimum amount %' |
            translate :
            (currencySymbol + minAmount)}}</span>{{minAmount && maxAmount ? ',' : ''}}&nbsp;<span
              [ngClass]="{'col-2' : maxError}">{{'Maximum amount %' |
            translate :
            (currencySymbol + maxAmount)}}</span>
    </div>
</div>
}
